import { ACTION_TYPES } from '../constants/actions';
import { KeyValue } from '../types/common.types';

interface EkycState {
  isLoading?: boolean;
  isInitEkycError?: boolean;
  isVerifyEkycError?: boolean;
  initEkycpayload?: KeyValue | null;
  verifyEkycPayload?: KeyValue | null;
  verifyMcssEkycPayload?: KeyValue | null;
}

const initialState: EkycState = {
  isInitEkycError: false,
  isVerifyEkycError: false,
  isLoading: false,
  initEkycpayload: null,
  verifyEkycPayload: null
};

type EkycActions = {
  type: string;
  payload?: string;
};

export const eKycReducer = (
  state: EkycState = initialState,
  action: EkycActions
) => {
  switch (action.type) {
    case ACTION_TYPES.EKYC.EKYC_INITIALIZATION_LOADING: {
      return {
        ...state,
        isLoading: true,
        isInitEkycError: false
      };
    }
    case ACTION_TYPES.EKYC.EKYC_INITIALIZATION_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isInitEkycError: false,
        initEkycpayload: action.payload
      };
    }
    case ACTION_TYPES.EKYC.EKYC_INITIALIZATION_FAILURE: {
      return {
        ...state,
        isLoading: false,
        isInitEkycError: true
      };
    }
    case ACTION_TYPES.EKYC.EKYC_VERIFICATION_LOADING: {
      return {
        ...state,
        isLoading: true,
        isVerifyEkycError: false
      };
    }
    case ACTION_TYPES.EKYC.EKYC_VERIFICATION_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isVerifyEkycError: false,
        verifyEkycPayload: action.payload
      };
    }
    case ACTION_TYPES.EKYC.EKYC_VERIFICATION_FAILURE: {
      return {
        ...state,
        isLoading: false,
        isVerifyEkycError: true
      };
    }
    case ACTION_TYPES.PAYMENT.CLEAR_BUY_FLOW_DATA: {
      return {
        ...initialState
      };
    }
  }
  return state;
};
